<template>
    <h2 class="mt-0">Spinners</h2>
    <div class="between flex w-full border">
        <fieldset class="mb-4 flex w-full flex-col px-4 py-2">
            <h3 class="mt-4 text-base">
                <small class="text-base">(xs / 0.75rem / 12px)</small>
            </h3>
            <DsSpinner size="xs" />
            <h3 class="mt-4 text-base">
                <small class="text-base">(sm / 1rem / 16px)</small>
            </h3>
            <DsSpinner size="sm" />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(md / 1.5rem / 24px)</small>
            </h3>
            <DsSpinner size="md" />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(lg / 2rem / 32px)</small>
            </h3>
            <DsSpinner size="lg" />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(xl / 2.5rem / 40px)</small>
            </h3>
            <DsSpinner size="xl" />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(xxl / 3rem / 48px)</small>
            </h3>
            <DsSpinner size="xxl" />
            <h3 class="mb-3 mt-4 text-base">With slots and classes</h3>
            <DsSpinner
                class="flex w-32 flex-col items-center justify-center p-4"
                size="xl"
                sr-text="Loading with custom text..."
            >
                <template #before>
                    <h4 class="text-base">Loading...</h4>
                </template>
                <template #after>
                    <p class="text-sm">Please wait</p>
                </template>
            </DsSpinner>
            <h3 class="mb-3 mt-4 text-base">Page loading</h3>
            <DsSpinner
                centerIcon="fak fa-cl-logo"
                centerIconSize="xl"
                size="xxxl"
                variant="brand"
            />
        </fieldset>
        <fieldset class="mb-4 flex w-full flex-col px-4 py-2">
            <h3 class="mt-4 text-base">
                <small class="text-base">(primary)</small>
            </h3>
            <DsSpinner
                size="xxl"
                variant="primary"
            />
            <h3 class="mt-4 text-base">
                <small
                    class="text-base"
                    size="xxl"
                    >(secondary)
                </small>
            </h3>
            <DsSpinner
                size="xxl"
                variant="secondary"
            />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(destructive)</small>
            </h3>
            <DsSpinner
                size="xxl"
                variant="destructive"
            />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(brand)</small>
            </h3>
            <DsSpinner
                centerIcon="fak fa-cl-logo"
                centerIconSize="md"
                size="xxl"
                variant="brand"
            />
            <h3 class="mb-3 mt-4 text-base">
                <small class="text-base">(inverse)</small>
            </h3>
            <div class="flex rounded-md bg-ds-primary-800 p-4">
                <DsSpinner
                    size="xxl"
                    variant="inverse"
                />
            </div>
        </fieldset>
    </div>
</template>

<script setup lang="ts">
import DsSpinner from '@/components/design-system/spinner/DsSpinner.vue';
</script>

<style scoped lang="scss">
h2,
h3 {
    @apply my-4;
}
</style>
